module.exports = __webpack_public_path__ + "static/media/head0.9a50ea57.jpg";